// @ts-nocheck
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import siteMessage from "@insite/client-framework/SiteMessage";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getSettingsCollection } from "@insite/client-framework/Store/Context/ContextSelectors";
import translate from "@insite/client-framework/Translate";
import { OrderModel } from "@insite/client-framework/Types/ApiModels";
import ProductBrand, { ProductBrandStyles } from "@insite/content-library/Components/ProductBrand";
import { ProductDescriptionStyles } from "@insite/content-library/Components/ProductDescription";
import GridContainer, { GridContainerProps } from "@insite/mobius/GridContainer";
import GridItem, { GridItemProps } from "@insite/mobius/GridItem";
import { LinkPresentationProps } from "@insite/mobius/Link";
import Tooltip, { TooltipPresentationProps } from "@insite/mobius/Tooltip";
import Typography, { TypographyPresentationProps, TypographyProps } from "@insite/mobius/Typography";
import getColor from "@insite/mobius/utilities/getColor";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import Block, { BlockProps } from "@store/Library/Components/Toolkit/Block";
import ProductImage, { ProductImageStyles } from "@store/Overrides/Components/ProductImage";
import updateChangeRequestOrder from "@store/Framework/Store/Greif/Pages/RequestOrderChange/Handler/UpdateChangeRequestOrder";
import OrderChangeRequestAddedLineRequest from "@store/Library/Components/OrderChangeRequest/OrderChangeRequestAddedLineRequest";
import Status from "@store/Library/Components/Status";
import {
    AddedItemModel,
    ChangeRequestModel,
} from "@store/Library/Widgets/RequestOrderChange/RequestOrderChangePageContainer";
import { OrderRequestReasonModel } from "@store/Library/Widgets/RequestOrderChange/RequestOrderChangeProductList";
import ProductDescription from "@store/Overrides/Components/ProductDescription";
import ProductPartNumbers, { ProductPartNumbersStyles } from "@store/Overrides/Components/ProductPartNumbers";
import { orderChangeProps } from "@store/Themes/common/props/orderChange";
import { productLineProps } from "@store/Themes/common/props/productLine";
import useMergeProps from "@toolkit/Framework/Common/Hooks/useMergeProps";
import mergeProps from "@toolkit/Framework/Common/Utilities/mergeProps";
import React, { FC, useEffect, useState } from "react";
import { connect, ResolveThunks, useSelector } from "react-redux";
import { css } from "styled-components";

interface OwnProps {
    extendedStyles?: OrderChangeRequestAddedLineNotesStyles;
    changeRequestReasons: OrderRequestReasonModel[];
    orderDate: Date | null;
}

const mapStateToProps = (state: ApplicationState) => ({
    wishListSettings: getSettingsCollection(state).wishListSettings,
    enableVat: getSettingsCollection(state).productSettings.enableVat,
    vatPriceDisplay: getSettingsCollection(state).productSettings.vatPriceDisplay,
    changeRequestOrder: state.greif.pages.orderChange.changeRequestOrder,
});

const mapDispatchToProps = {
    updateChangeRequestOrder,
};

type Props = OwnProps & ReturnType<typeof mapStateToProps> & ResolveThunks<typeof mapDispatchToProps>;

export interface OrderChangeRequestAddedLineNotesStyles {
    typographyStyles?: TypographyProps;
    gridItemStyles?: GridItemProps;
    wrapper?: InjectableCss;
}

export interface OrderChangeRequestAddedLinesListStyles {
    orderLineCardGridContainer?: GridContainerProps;
    orderLineCartWrapper?: InjectableCss;
    orderLineCardImageGridItem?: GridItemProps;
    orderLineCardInfoGridItem?: GridItemProps;
    orderLineCardInfoGridContainer?: GridContainerProps;
    productBrandStyles?: ProductBrandStyles;
    productInfoPartNumbersGridItem?: GridItemProps;
    productInfoGridItem?: GridItemProps;
    productInfoBrandDescriptionGridItem?: GridItemProps;
    productDescriptionStyles?: ProductDescriptionStyles;
    orderLinePriceGridItem?: GridItemProps;
    block?: BlockProps;
    productImage?: ProductImageStyles;
    actionLink?: LinkPresentationProps;
    orderLineInfoContainer?: GridContainerProps;
    productPartNumbers?: ProductPartNumbersStyles;
    linkWrapper?: InjectableCss;
    addedTag?: InjectableCss;
    addedLineOverlayItem?: GridItemProps;
    ftlWrapper?: InjectableCss;
    leadTimeWrapper?: InjectableCss;
    shipFromLabel?: TypographyPresentationProps;
    shipFromText?: TypographyPresentationProps;
    leadTimeText?: TypographyPresentationProps;
    leadTimeTooltip?: TooltipPresentationProps;
}

export const orderChangeRequestLinesListStyles: OrderChangeRequestAddedLinesListStyles = {
    block: orderChangeProps.block,
    orderLineCardGridContainer: orderChangeProps.orderLineCardGridContainer,
    orderLineCartWrapper: orderChangeProps.orderLineCartWrapper,
    orderLineCardImageGridItem: productLineProps.imageGridItem,
    productImage: productLineProps.image,
    actionLink: productLineProps.addToListLink,
    orderLineCardInfoGridItem: productLineProps.contentGridItem,
    orderLineCardInfoGridContainer: productLineProps.contentContainer,
    productInfoGridItem: productLineProps.infoGridItem,
    orderLineInfoContainer: productLineProps.contentContainer,
    productInfoBrandDescriptionGridItem: productLineProps.descriptionGridItem,
    productBrandStyles: productLineProps.brand,
    productDescriptionStyles: productLineProps.description,
    productInfoPartNumbersGridItem: productLineProps.partNumbersGridItem,
    productPartNumbers: productLineProps.partNumbers,
    addedLineOverlayItem: orderChangeProps.addedLineOverlayItem,
    addedTag: orderChangeProps.addedTag,
    ftlWrapper: orderChangeProps.ftlWrapper,
    shipFromLabel: orderChangeProps.shipFromLabel,
    leadTimeText: orderChangeProps.leadTimeText,
    leadTimeTooltip: orderChangeProps.leadTimeTooltip,
};

const OrderChangeRequestAddedLineProductInfo = ({
    newLine,
    styles,
    orderDate,
}: {
    newLine: AddedItemModel;
    styles: OrderChangeRequestAddedLinesListStyles;
    orderDate: Date | null;
}) => {
    const { language } = useSelector((state: ApplicationState) => state.context.session);
    const currentLeadTime = JSON.parse(newLine.product.properties.leadTimes)[0];

    return (
        <GridItem {...styles.productInfoGridItem}>
            <GridContainer {...styles.orderLineInfoContainer}>
                <GridItem {...styles.productInfoBrandDescriptionGridItem}>
                    {newLine.product.brand && (
                        <ProductBrand brand={newLine.product.brand} extendedStyles={styles.productBrandStyles} />
                    )}
                    <ProductDescription product={newLine} extendedStyles={styles.productDescriptionStyles} />
                </GridItem>
                <GridItem {...styles.productInfoPartNumbersGridItem}>
                    <ProductPartNumbers
                        productNumber={newLine.product.productNumber}
                        customerProductNumber={newLine.product.customerProductNumber}
                        manufacturerItem={newLine.product.manufacturerItem}
                        extendedStyles={styles.productPartNumbers}
                    />
                    {newLine.product.properties.FullTruckLoad && (
                        <StyledWrapper {...styles.ftlWrapper}>
                            <Typography {...styles.shipFromLabel}>
                                {translate("Full Truck Load")}
                                {translate(":")}
                            </Typography>
                            <Typography
                                {...styles.shipFromText}
                            >{` ${newLine.product.properties.FullTruckLoad}`}</Typography>
                        </StyledWrapper>
                    )}
                    {currentLeadTime && (
                        <StyledWrapper {...styles.leadTimeWrapper}>
                            {currentLeadTime.IsSpecialItem ? (
                                <Status showIcon type="yellow">
                                    <Typography {...styles.leadTimeText}>
                                        {Number(currentLeadTime.LeadTime) === 1
                                            ? translate(
                                                  "Lead Time {0} week for minimum order quantity of {1} units.",
                                                  String(currentLeadTime.LeadTime),
                                                  String(currentLeadTime.MinimumOrderQuantity),
                                              )
                                            : translate(
                                                  "Lead Time {0} weeks for minimum order quantity of {1} units.",
                                                  String(currentLeadTime.LeadTime),
                                                  String(currentLeadTime.MinimumOrderQuantity),
                                              )}
                                    </Typography>
                                    <Tooltip
                                        {...styles.leadTimeTooltip}
                                        text={siteMessage("OrderChangeRequest_LeadTimeTooltipSpecialProduct") as string}
                                    />
                                </Status>
                            ) : (
                                <Status showIcon type="green">
                                    <StyledWrapper>
                                        <Typography {...styles.leadTimeText}>
                                            {Number(currentLeadTime.LeadTime) === 1
                                                ? translate("Lead Time {0} week.", String(currentLeadTime.LeadTime))
                                                : translate("Lead Time {0} weeks.", String(currentLeadTime.LeadTime))}
                                        </Typography>
                                        <Tooltip
                                            {...styles.leadTimeTooltip}
                                            text={
                                                siteMessage(
                                                    "OrderChangeRequest_LeadTimeTooltipRegularProduct",
                                                ) as string
                                            }
                                        />
                                    </StyledWrapper>
                                </Status>
                            )}
                        </StyledWrapper>
                    )}
                </GridItem>
            </GridContainer>
        </GridItem>
    );
};

const OrderChangeRequestAddedLineCard = (props: {
    newLine: AddedItemModel;
    styles: OrderChangeRequestAddedLinesListStyles;
    changeRequestReasons: OrderRequestReasonModel[];
    changeRequestOrder: ChangeRequestModel;
    orderDate: Date | null;
}) => {
    const { newLine, styles, changeRequestReasons, changeRequestOrder, orderDate } = props;

    const [currentLine, setCurrentLine] = useState<AddedItemModel>({} as AddedItemModel);

    useEffect(() => {
        if (changeRequestOrder) {
            const line = changeRequestOrder?.newLines?.find(l => l.product.id === newLine.product.id);
            setCurrentLine(line!);
        }
    }, [changeRequestOrder]);

    const orderLineCartWrapperStyles: InjectableCss = mergeProps(styles.orderLineCartWrapper, {
        css: css`
            border-color: ${getColor("success")};
        `,
    });

    return (
        <StyledWrapper {...orderLineCartWrapperStyles}>
            <GridContainer
                {...styles.orderLineCardGridContainer}
                data-test-selector={`orderLineCard${newLine.product.id}`}
            >
                <GridItem {...styles.addedLineOverlayItem}>
                    <StyledWrapper {...styles.addedTag}>
                        <Typography>{translate("Added")}</Typography>
                    </StyledWrapper>
                </GridItem>
                <GridItem {...styles.orderLineCardImageGridItem}>
                    <ProductImage product={newLine.product} size="medium" extendedStyles={styles.productImage} />
                </GridItem>
                <GridItem {...styles.orderLineCardInfoGridItem}>
                    <GridContainer {...styles.orderLineCardInfoGridContainer}>
                        <OrderChangeRequestAddedLineProductInfo
                            newLine={newLine}
                            styles={styles}
                            orderDate={orderDate}
                        />
                    </GridContainer>
                </GridItem>
            </GridContainer>
            {newLine.product.id && (
                <GridContainer>
                    <GridItem width={12}>
                        <OrderChangeRequestAddedLineRequest
                            newLine={newLine}
                            changeRequestReasons={changeRequestReasons}
                            currentLine={currentLine}
                        />
                    </GridItem>
                </GridContainer>
            )}
        </StyledWrapper>
    );
};

const OrderChangeRequestAddedLinesList: FC<Props> = ({
    extendedStyles,
    changeRequestReasons,
    changeRequestOrder,
    orderDate,
}) => {
    const styles = useMergeProps(orderChangeRequestLinesListStyles, extendedStyles);

    if (!changeRequestOrder?.newLines || !changeRequestOrder?.newLines[0]?.product?.id) {
        return null;
    }

    return (
        <Block {...styles.block}>
            {changeRequestOrder?.newLines?.map(newLine => (
                <OrderChangeRequestAddedLineCard
                    newLine={newLine}
                    styles={styles}
                    key={newLine.product.id + 1}
                    changeRequestReasons={changeRequestReasons}
                    changeRequestOrder={changeRequestOrder}
                    orderDate={orderDate}
                />
            ))}
        </Block>
    );
};

export default connect(mapStateToProps, mapDispatchToProps)(OrderChangeRequestAddedLinesList);
